/**
 * StyleX styles for the StatCard component.
 */

import * as stylex from "@stylexjs/stylex";

import { colors, radius, space } from "@animus/primaris/tokens.stylex";

export const styles = stylex.create({
  card: {
    borderRadius: radius.lg,
    backgroundColor: colors.muted,
    padding: space.lg,
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: space.sm,
  },
  title: {
    fontSize: "0.875rem",
    color: colors.foregroundMuted,
  },
  value: {
    marginTop: space.sm,
    fontWeight: 700,
    fontSize: "1.875rem",
    lineHeight: "2.25rem",
  },
  blue: { color: colors.primary },
  red: { color: colors.destructive },
  green: { color: colors.success },
});
